
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v11h3c.335 0 .667.014 1 .02v5.998C3.667 17.015 3.33 17 3 17H0v11h2.102c.466 2.275 2.49 4 4.898 4 2.407 0 4.431-1.725 4.898-4h2.204c.466 2.275 2.49 4 4.898 4 1.97 0 3.668-1.157 4.48-2.824a12.722 12.722 0 012.733 2.441c.189.241.48.383.787.383h14a1 1 0 00.707-1.707L39.414 28H29a1 1 0 110-2h8.414l2 2c7.563-.422 8.59-3.6 8.584-4.951-.01-2.193-1.081-3.977-4.373-6.588l-.223-.182c-5.558-4.59-12.82-8.897-21.004-12.447C14.258.299 6.638.023 2.373.002 1.997 0 1.647 0 1.326 0H0zm12.908 2.98c2.726.542 5.677 1.379 8.694 2.688 4.16 1.806 8.14 3.86 11.765 6.043-3.244-.415-8.893-1.33-13.492-3.086-3.91-1.493-5.654-4.069-6.967-5.645zM6 11.088c2.406.124 4.757.383 7 .736v5.574a155.395 155.395 0 00-7-.345v-5.965zm9 1.078c2.155.4 4.146.875 6 1.37l-.771 4.51A198.818 198.818 0 0015 17.544v-5.377zm7.938 1.902c2.881.845 5.244 1.702 6.767 2.34a.498.498 0 01.186.783l-1.385 1.645a.487.487 0 01-.447.174c-.693-.103-3.006-.406-5.84-.737l.718-4.205zM4.181 28h5.636A2.974 2.974 0 017 30a2.974 2.974 0 01-2.818-2zm12 0H20c.584 0 1.153.115 1.695.297A2.982 2.982 0 0119 30a2.974 2.974 0 01-2.818-2z","fill":"#000"}})])
          )
        }
      }
    